import React from 'react'
import ContentLoader from 'react-content-loader'

const LoadingPlaceholder = ({ speed = 1, primaryColor = '#f3f3f3', secondaryColor = '#ecebeb' }) => (
  <>
    <ContentLoader
      viewBox='0 0 960 440'
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
      uniqueKey='recommender-md-skel'
      className='xs-hidden md-block'
    >
      <rect x='0' y='00' rx='0' ry='0' width='330' height='20' />
      <rect x='0' y='30' rx='0' ry='0' width='160' height='200' />
      <rect x='170' y='30' rx='0' ry='0' width='160' height='200' />
      <rect x='170' y='240' rx='0' ry='0' width='160' height='200' />
      <rect x='0' y='240' rx='0' ry='0' width='160' height='200' />
      <rect x='340' y='0' rx='0' ry='0' width='230' height='440' />
      <rect x='580' y='0' rx='0' ry='0' width='230' height='440' />
      <rect x='820' y='0' rx='0' ry='0' width='230' height='440' />
    </ContentLoader>
    <ContentLoader
      viewBox='0 0 320 630'
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
      uniqueKey='recommender-xs-skel'
      className='md-hidden'
    >
      <rect x='0' y='0' rx='0' ry='0' width='320' height='20' />
      <rect x='0' y='30' rx='0' ry='0' width='160' height='160' />
      <rect x='170' y='30' rx='0' ry='0' width='160' height='160' />
      <rect x='170' y='200' rx='0' ry='0' width='160' height='160' />
      <rect x='0' y='200' rx='0' ry='0' width='160' height='160' />
      <rect x='0' y='370' rx='0' ry='0' width='210' height='150' />
      <rect x='220' y='370' rx='0' ry='0' width='210' height='150' />
    </ContentLoader>
  </>
)

export default LoadingPlaceholder
